<template>
  <router-view/>
</template>
<script>
import axios from 'axios';
import HttpRequests from './httpRequests/httpRequests';

const httpRequests=new HttpRequests()
  export default{

    mounted(){

      axios.defaults.baseURL="https://api.ugcollege.ug.edu.ge/public/api"
      if(localStorage.getItem('token')){

        axios.defaults.headers.common.Authorization='Bearer '+localStorage.getItem('token')
        this.loginWithToken()
      }
       

  
    },
    methods:{

      loginWithToken(){

        httpRequests.loginWithToken().then(response=>{
          this.$store.dispatch('setUser',response.data)
          
        })


      }
    }

  }

</script>

